import { render, staticRenderFns } from "./CommercialUnassignedAllocationHistoryDrawer.vue?vue&type=template&id=b7b3d890&scoped=true"
import script from "./CommercialUnassignedAllocationHistoryDrawer.vue?vue&type=script&lang=js"
export * from "./CommercialUnassignedAllocationHistoryDrawer.vue?vue&type=script&lang=js"
import style0 from "./CommercialUnassignedAllocationHistoryDrawer.vue?vue&type=style&index=0&id=b7b3d890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b3d890",
  null
  
)

export default component.exports